/* eslint-disable indent */
import React, { useEffect, useState } from "react";
import {	correctPublicationsAtom,
	projectTitleAtom,
	setPublicationsCorrect } from "../utils/hooks/LoadingHook";
import { getAllPublicationIds, getProjectTitle } from "../graphql/queries/publicationQuery";
import Querying from "../Querying";
import { atom, useAtom } from "jotai";
import { Publication } from "../utils/hooks/types/publicationDataType";
import { PROJECT_ID } from "../page/Dashboard";
import { UNDEFINED } from "../App";

export const publicationsAtom = atom<Publication[]>([]);

/**
 *  Properties for the publication information
 */
type LoadPublicationsProps = {
    setLoaded: (isLoaded: boolean) => void;
};

/**
 *  Loads all publication information needed for the analytics
 *
 * @params setLoaded Checks if all the information has been loaded
 * @returns {JSX.Element} all loaded publications after querying
 */
export const LoadPublications = ({ setLoaded }: LoadPublicationsProps) => {
	const [publicationsRaw, setPublicationsRaw] = useState<Publication[]>([]);
	const [projectTitle, setProjectTitle] = useState<string>("");
	const [publicationsData, setPublicationsData] = useAtom(publicationsAtom);
	const [correctPublications, setCorrectPublications] = useAtom(correctPublicationsAtom);
	const [__, setProjectTitleAtom] = useAtom(projectTitleAtom);
	const [isPublicationIdsLoaded, setPublicationIdsLoaded] = useState(false);
	const [isProjectTitleLoaded, setProjectTitleLoaded] = useState(false);
	const [isPublicationLoaded, setPublicationLoaded] = useState(false);

	useEffect(() => {
		getAllPublicationIds(setPublicationsRaw, setPublicationIdsLoaded, PROJECT_ID);
		getProjectTitle(setProjectTitle, setProjectTitleLoaded, PROJECT_ID);
	}, []);

	useEffect(() => {
		if (isPublicationIdsLoaded && isProjectTitleLoaded) {
			if (publicationsData.length === publicationsRaw.length &&
				projectTitle.length > UNDEFINED) {
				setPublicationLoaded(true);
			}
		}
	}, [isPublicationIdsLoaded,
		setProjectTitleLoaded,
		publicationsData,
		projectTitle,
		setPublicationsData]);

	useEffect(() => {
		if (isPublicationLoaded) {
			setPublicationsCorrect(publicationsRaw, setCorrectPublications, setLoaded);
			setProjectTitleAtom(projectTitle);
		}
	}, [isPublicationLoaded, setPublicationLoaded]);

	return (
		<div>
			{
				(publicationsRaw.length > UNDEFINED
                && publicationsRaw.length !== publicationsData.length)
                && isPublicationIdsLoaded
                && publicationsRaw.map((rawPub, index) => {
                	return (
                		<Querying
                			key={rawPub.id}
                			publicationId={rawPub.id}
                			publication={(publication) => {
                				rawPub.data = publication;
                				setPublicationsData(() => [...publicationsData, publication]);
                			}}
                		/>
                	);
                })
			}
		</div>
	);
};

export default LoadPublications;